import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import get from 'lodash/get'

import useModal from 'hooks/useModal'
import {getChatUrlByRoomId} from 'utils/url.utils'
import {
  getSharingText,
  getWhatsAppSharingLink,
  getEmailSharingLink,
} from 'modules/chat/utils/sharing.utils'
import Icon from 'components/Icon'
import FormattedDate from 'components/FormattedDate'
import CopyToClipboard from 'components/CopyToClipboard'

const ShareDetails = ({defaultIsActive, children, room, pin}) => {
  const {isOpen, close, open} = useModal(defaultIsActive)

  const roomId = get(room, 'uid')
  const createdAt = get(room, 'createdAt')
  const description = get(room, 'description')
  const creatorName = get(room, 'creator.name')
  const chatUrl = getChatUrlByRoomId(roomId)

  return (
    <>
      <div onClick={open}>{children}</div>
      <div className={classNames('modal', {'is-active': isOpen})}>
        <div className="modal-background" onClick={close} />
        <div className="modal-content">
          <div className="box">
            <div className="media">
              <div className="media-content">
                <div className="content is-size-6">
                  <h4>Chat Details</h4>
                  <p>
                    {description}{' '}
                    <span className="is-size-7 has-text-grey-light is-italic">
                      by {creatorName}
                    </span>
                    <br />
                    {createdAt && (
                      <>
                        Created:{' '}
                        <FormattedDate
                          timestamp={createdAt}
                          format="eee do LLL yyyy"
                        />
                        <br />
                      </>
                    )}
                    {chatUrl}
                    <br />
                    PIN: <strong>{pin}</strong>
                  </p>
                </div>
                <div className="level is-mobile">
                  <div className="level-left">
                    <CopyToClipboard
                      className="level-item"
                      text={getSharingText(room, pin)}>
                      <button className="button is-small is-white ">
                        <span className="icon">
                          <Icon icon="copy" />
                        </span>
                        <span>Copy</span>
                      </button>
                    </CopyToClipboard>
                    <div className="level-item">
                      <a
                        className="button is-small is-white"
                        href={getEmailSharingLink(room, pin)}>
                        <span className="icon">
                          <Icon icon="envelope" />
                        </span>
                        <span>Share</span>
                      </a>
                    </div>
                    <div className="level-item">
                      <a
                        className="button is-small is-white"
                        href={getWhatsAppSharingLink(room, pin)}
                        target="_blank">
                        <span className="icon">
                          <Icon icon={['fab', 'whatsapp']} />
                        </span>
                        <span>Share</span>
                      </a>
                    </div>
                  </div>
                  <div className="level-right" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          className="modal-close is-large"
          aria-label="close"
          onClick={close}
        />
      </div>
    </>
  )
}

ShareDetails.defaultProps = {
  defaultIsActive: false,
  children: (
    <button
      type="button"
      className="button is-white"
      data-tooltip="Share Details">
      <span className="icon">
        <Icon icon="share-alt" size="lg" />
      </span>
    </button>
  ),
}

ShareDetails.propTypes = {
  children: PropTypes.node.isRequired,
  defaultIsActive: PropTypes.bool,
  pin: PropTypes.string.isRequired,
  room: PropTypes.shape({
    createdAt: PropTypes.number,
    description: PropTypes.string,
    creator: PropTypes.shape({
      uid: PropTypes.string,
      name: PropTypes.string,
    }),
  }).isRequired,
}

export default ShareDetails
